import { render, staticRenderFns } from "./riskHistory.vue?vue&type=template&id=93222f48&scoped=true&"
import script from "./riskHistory.vue?vue&type=script&lang=js&"
export * from "./riskHistory.vue?vue&type=script&lang=js&"
import style0 from "./riskHistory.vue?vue&type=style&index=0&id=93222f48&scoped=true&lang=css&"
import style1 from "./riskHistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93222f48",
  null
  
)

export default component.exports